import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import VerifyEmail from "./screens/VerifyEmail/VerifyEmail";
import ProfilePage from "./screens/ProfilePage/ProfilePage";
import OrdersPage from "./screens/OrdersPage/OrdersPage";
import LektorPage from "./screens/LektorPage/LektorPage";
import AdminPage from "./screens/AdminPage/AdminPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import SiteHeader from "./components/SiteHeader/SiteHeader";
import { ConsentProvider } from "./consent/ConsentProvider";
import AnalyticsLoader from "./analytics/AnalyticsLoader";
import AppFooter from "./components/AppFooter/AppFooter";
import FloatingCartBar from "./components/FloatingCartBar/FloatingCartBar";
import HomePage from "./screens/HomePage/HomePage";
import RozvrhDetiPage from "./screens/RozvrhDetiPage/RozvrhDetiPage";
import KosikPage from "./screens/KosikPage/KosikPage";
import SiteGate from "./components/SiteGate/SiteGate";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import ErrorModal from "./components/ErrorModal/ErrorModal";
import GdprPage from "./screens/Gdpr/GdprPage";
import VopPage from "./screens/Vop/VopPage";
import CookiesPage from "./screens/Cookies/CookiesPage";

function ProtectedRoute({ children }) {
  const { isLoggedIn, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isLoggedIn) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { isLoggedIn, isAdmin, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isLoggedIn || !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function LektorRoute({ children }) {
  const { isLoggedIn, isLektor, isAdmin, authLoading } = useAuth();
  if (authLoading) return null;
  if (!isLoggedIn || !(isLektor || isAdmin)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const location = useLocation();
  const hideFooter = false ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/profil") ||
    location.pathname.startsWith("/objednavky") ||
    location.pathname.startsWith("/moje-objednavky") ||
    location.pathname.startsWith("/moj-rozvrh") ||
    location.pathname.startsWith("/lektor");
  return (
    <SiteGate active={window.location.hostname !== "triferis.sk"}>
      <ConsentProvider>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <ErrorModal />
            <div className="App">
              {/* Header */}
              <SiteHeader />

              <Routes>
                <Route path="/" element={<HomePage />} />
                {/* <Route path="o-nas" element={<HomePage />} />
                <Route path="ponuka" element={<HomePage />} />
                <Route path="katalog-clenstiev" element={<HomePage />} />
                <Route path="clenstva" element={<HomePage />} />
                <Route path="kosik" element={<KosikPage />} />
                <Route path="cart" element={<KosikPage />} />
                <Route path="kontakt" element={<Navigate to="/#kontakt" replace />} />
                <Route path="rozvrh" element={<Navigate to="/#rozvrh" replace />} />
                <Route
                  path="moj-rozvrh"
                  element={
                    <ProtectedRoute>
                      <RozvrhDetiPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="profil"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="moje-objednavky"
                  element={
                    <ProtectedRoute>
                      <OrdersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="objednavky"
                  element={
                    <ProtectedRoute>
                      <OrdersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="lektor"
                  element={
                    <LektorRoute>
                      <LektorPage />
                    </LektorRoute>
                  }
                />
                <Route
                  path="admin"
                  element={
                    <AdminRoute>
                      <AdminPage />
                    </AdminRoute>
                  }
                />
                <Route path="verify-email" element={<VerifyEmail />} /> */}
                <Route path="ochrana-osobnych-udajov" element={<GdprPage />} />
                <Route
                  path="vseobecne-obchodne-podmienky"
                  element={<VopPage />}
                />
                <Route path="cookie-politika" element={<CookiesPage />} />
                <Route path="*" element={<h1>Stránka nenájdená</h1>} />
              </Routes>
              {/* <FloatingCartBar /> */}
              {!hideFooter && <AppFooter />}
            </div>
            <AnalyticsLoader />
          </CartProvider>
        </AuthProvider>
      </ConsentProvider>
    </SiteGate>
  );
}

export default App;
